// '기타'·미분류는 외용약의 근거가 아니므로 복용 문구를 기본으로 사용한다.
export const isOral = (intakeForm) => !['TOPICAL', 'PATCH', 'SPRAY', 'INSERT'].includes(intakeForm);
